import numeral from 'numeral';

export const scoreFormatter = (score?: string | number | null): string => {
  const value = typeof score === 'string' ? parseFloat(score) : score;
  if (typeof value === 'undefined' || value === null || Number.isNaN(value)) {
    return '-';
  }

  return numeral(score).format('0.0');
};
